module.exports = __webpack_public_path__ + "img/content7-11.2c525c3a.webp";